import { Box, Slider, Typography } from "@mui/material";
import { Option } from "../../../types/option";

type SliderFieldProps = {
  label: string;
  data: Option[];
  valueLabelDisplay : "auto" | "off" | "on" | undefined,
  defaultValue: number;
  onChange: (value: number | number[]) => void;
};

export default function SliderField({
  label,
  data,
  defaultValue,
  valueLabelDisplay,
  onChange,
}: SliderFieldProps) {
  return (
    <Box>
      <Typography mb={1}>{label}</Typography>
      <Slider
        valueLabelDisplay={valueLabelDisplay}
        step={null}
        marks={data}
        defaultValue={defaultValue}
        onChange={(_: Event, value: number | number[]) => onChange(value)}
      />
    </Box>
  );
}
